export class SyncData {
  id: string;
  lastSyncAt?: string;
  bioforestUrl?: string;

  constructor(data?: Partial<SyncData>) {
    this.id = data?.id ?? 'sync-data';
    this.lastSyncAt = data?.lastSyncAt;
    this.bioforestUrl = data?.bioforestUrl;
  }
}
